import { render, staticRenderFns } from "./DIASRealEstateStatus.vue?vue&type=template&id=71fabc83&"
import script from "./DIASRealEstateStatus.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports